import { ID_TO_PAGE_CONFIG_MAP } from 'constants/pages-configs-map'
import { TPageConfig } from 'models/common.model'

export const getPageById = (
  id: string,
  shouldHideProgress?: boolean,
): TPageConfig | undefined => {
  const page = Object.values(ID_TO_PAGE_CONFIG_MAP).find(
    (component) => component.id === id,
  )

  if (!page) return undefined

  if (shouldHideProgress) {
    return {
      ...page,
      progressBar: 'uncontrolled',
      progressBarHidden: true,
    }
  }

  return page
}
